import { useMediaQuery } from "@mui/material";
import React, { useCallback, useEffect, useRef, useState } from "react";

const useFooterModal = () => {
  const isMobile = useMediaQuery("(max-width: 767px)");

  const [openFooterModal, setOpenFooterModal] = useState(false);
  const footerRef = useRef(null);
  const arrowButRef = useRef(null);

  const toggleFooterState = (e) => {
    e.preventDefault();

    e.stopPropagation();
    setOpenFooterModal(!openFooterModal);
    if (isMobile) {
      document.body.style.overflow = "hidden";
    }
  };

  const onClose = () => {
    setOpenFooterModal(false);
  };

  const closeFooterModal = useCallback(
    (event) => {
      if (
        footerRef.current &&
        !arrowButRef.current.contains(event.target) &&
        !footerRef.current.contains(event.target)
      ) {
        setOpenFooterModal(false);
        if (isMobile) {
          document.body.style.overflow = "";
        }
      }
    },
    [isMobile]
  );

  useEffect(() => {
    if (openFooterModal) {
      document.addEventListener("mousedown", closeFooterModal);
    }
    return () => {
      document.removeEventListener("mousedown", closeFooterModal);
    };
  }, [openFooterModal, closeFooterModal]);

  return {
    toggleFooterState,
    footerRef,
    openFooterModal,
    onClose,
    arrowButRef,
  };
};

export default useFooterModal;
